import React from 'react';
import { Switch } from 'react-router-dom';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import Comptable from './comptable';
import ComptableUpdate from './comptable-update';
import ComptableDetail from './comptable-details';
import ComptableModal from './comptable-modal-delete';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/new`} component={ComptableUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/edit`} component={ComptableUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/details`} component={ComptableDetail} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid`} component={Comptable} />
    </Switch>
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/delete`} component={ComptableModal} />
  </>
);

export default Routes;
